import styled from 'styled-components'
import theme from '../../theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 1rem;
  background-color: ${theme.colors.background.color};
  min-height: 100%;
  padding: 1rem;
  width: 100%;

  @media (max-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
`

export const FullRow = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const DatePickerBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  border: 2px solid blue;
`
export const Title = styled.div`
  display: flex;

  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export const SummaryDataWrapper = styled.div`
  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
  }
`
export const LineChartDataWrapper = styled.div`
  gap: 1rem;
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export const DetailedCardSectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;

  @media (max-width: 1200px) {
    display: block;
  }
`
